// extracted by mini-css-extract-plugin
module.exports = {"root":"Booking_root__2Kf3b","title":"Booking_title__3nWUr","titleActive":"Booking_titleActive__mtNdb","login":"Booking_login__3dN_X","noTickets":"Booking_noTickets__WGstL"};